module.exports = __webpack_public_path__ + "static/media/webd6.94168013.jpg";